// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__VdXWM","buttonGroup":"ResetPassword_buttonGroup__Gzlu6"};